import { Component, ViewEncapsulation } from '@angular/core';
import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { IStatusPanelParams } from 'ag-grid-community';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import _ from 'underscore';

export const AG_PAGINATION_KEY:string = 'statusBarPaginationComp';
export type OnPageChangedEvent = (event:PageChangedEvent) => void;

export interface IAgPaginationParams extends IStatusPanelParams {
  // max button visible on the screen
  maxSize?:number;
  // items visible per page (default: 10)
  itemsPerPage?:number;
  // triggered when page changes
  onPageChanged:OnPageChangedEvent;
}

interface IPaginationRefreshConfig {
  totalItems?:number;
  currentPage?:number;
  disabled?:boolean;
}

@Component({
  selector: 'ag-pagination',
  template: `
    <div class="row pagination-container">
      <div class="col-sm-12">
        <pagination 
          class="pagination-sm"
          [totalItems]="totalItems" 
          [maxSize]="params.maxSize || 5" 
          [itemsPerPage]="params.itemsPerPage || 10"
          [boundaryLinks]="true"
          [rotate]="false"
          [disabled]="disabled"
          previousText="&lsaquo;" 
          nextText="&rsaquo;" 
          firstText="&laquo;" 
          lastText="&raquo;"
          [(ngModel)]="currentPage"
          (pageChanged)="onPageChanged($event)">
        </pagination>
      </div>
    </div>
  `,
  styleUrls: ['./ag-pagination.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AgPaginationComponent implements IStatusPanelAngularComp {
  public params!:IAgPaginationParams;
  public totalItems:number;
  public currentPage:number;
  public disabled:boolean;

  public agInit(params:IAgPaginationParams) {
    this.params = params;
  }

  public refreshPagination(config:IPaginationRefreshConfig):void {
    this.totalItems = _.isUndefined(config?.totalItems) ? this.totalItems : config.totalItems;
    this.currentPage = _.isUndefined(config?.currentPage) ? this.currentPage : config.currentPage;
    this.disabled = _.isUndefined(config?.disabled) ? this.disabled : config.disabled;
  }

  public onPageChanged(event:PageChangedEvent):void {
    if (this.params.onPageChanged) {
      this.params.onPageChanged(event);
    }
  }
}